import { ROUTES } from '@/router/routeNames'

export default [
  {
    name: ROUTES.INSIGHTS,
    path: 'insights',
    component: () => import('./pages/InsightsIndex.vue')
  }
]
